import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Audio from '../../static/images/resources/icon-audio-y.svg'
import Document from '../../static/images/resources/icon-document-y.svg'
import GameApp from '../../static/images/resources/icon-app-y.svg'
import Image from '../../static/images/resources/icon-image-y.svg'
import Presentation from '../../static/images/resources/icon-presentation-y.svg'
import Video from '../../static/images/resources/icon-video-y.svg'
import Web from '../../static/images/resources/icon-web-y.svg'
import Simulation from '../../static/images/resources/icon-simulation-y.svg'

const TypeIcon = styled.div`
  background-repeat: no-repeat;
  background-size: 100%;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  margin-right: 15px;
`

const AudioTypeIcon = styled(TypeIcon)`
  background-image: url(${Audio});
  background-size: contain;
`

const DocumentTypeIcon = styled(TypeIcon)`
  background-image: url(${Document});
  background-size: contain;
`

const GameAppTypeIcon = styled(TypeIcon)`
  background-image: url(${GameApp});
  background-size: contain;
`

const ImageTypeIcon = styled(TypeIcon)`
  background-image: url(${Image});
  background-size: contain;
`

const PresentationTypeIcon = styled(TypeIcon)`
  background-image: url(${Presentation});
  background-size: contain;
`

const VideoTypeIcon = styled(TypeIcon)`
  background-image: url(${Video});
  background-size: contain;
`

const WebTypeIcon = styled(TypeIcon)`
  background-image: url(${Web});
  background-size: contain;
`

const SimulationTypeIcon = styled(TypeIcon)`
  background-image: url(${Simulation});
  background-size: contain;
`

const FileTypeIcon = ({type, size}) => {
  let icon = null
  switch (type) {
    case 'audio': {
      icon = <AudioTypeIcon size={size}/>
      break
    }
    case 'document': {
      icon = <DocumentTypeIcon size={size}/>
      break
    }
    case 'game_app': {
      icon = <GameAppTypeIcon size={size}/>
      break
    }
    case 'image': {
      icon = <ImageTypeIcon size={size}/>
      break
    }
    case 'presentation': {
      icon = <PresentationTypeIcon size={size}/>
      break
    }
    case 'video': {
      icon = <VideoTypeIcon size={size}/>
      break
    }
    case 'web': {
      icon = <WebTypeIcon size={size}/>
      break
    }
    case 'simulation': {
      icon = <SimulationTypeIcon size={size}/>
      break
    }
  }
  return <span className="quest-type-icon">{icon}</span>
}

FileTypeIcon.defaultProps = {
  size: 25
}

FileTypeIcon.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.number
}

export default FileTypeIcon



// WEBPACK FOOTER //
// ./src/components/mini/FileTypeIcon.js